<mat-card-title>Test Contact</mat-card-title>

<div class="flex row">
    <mat-form-field class="w-full">
        <mat-label>Select a contact to test</mat-label>
        <mat-select [(ngModel)]="selectedContact">
            <mat-option *ngFor="let contact of contacts" [value]="contact.displayable">
                <mat-icon *ngIf="contact.value.contact_type === 'SMS'" aria-hidden="false" aria-label="SMS Text"
                          matTooltip="SMS" class="mr-2" fontIcon="perm_phone_msg">
                </mat-icon>
                <mat-icon *ngIf="contact.value.contact_type === 'VOICE'" aria-hidden="false" aria-label="Voice"
                          matTooltip="Voice" class="mr-2" fontIcon="phone">
                </mat-icon>
                <mat-icon *ngIf="contact.value.contact_type === 'EMAIL'" aria-hidden="false" aria-label="EMail"
                          matTooltip="Email" class="mr-2" fontIcon="email">
                </mat-icon>
                <mat-icon *ngIf="contact.value.contact_type === 'WEBHOOK'" aria-hidden="false" aria-label="Chat"
                          matTooltip="Chat - DECOMMISSIONED" color="warn" fontIcon="message">
                </mat-icon>
                <mat-icon *ngIf="contact.value.contact_type === 'TEAMS'" aria-hidden="false" aria-label="Teams"
                          matTooltip="Teams" fontIcon="supervisor_account">
                </mat-icon>
                {{contact.displayable}}
            </mat-option>
        </mat-select>
    </mat-form-field>
</div>

<mat-dialog-actions class="cmn-flex row space-between">
    <button [mat-dialog-close]="selectedContact" color="primary" matTooltip="Send Test Message" mat-raised-button> Send </button>
    <button [mat-dialog-close]="false" color="primary" mat-raised-button> Cancel </button>
</mat-dialog-actions>
